import { Injectable } from '@angular/core';

@Injectable()
export class LanguageApp {
  public static spanish_datatables = {
    //processing: "Procesando...",
    search: "<span>Buscar:</span>",
    searchPlaceholder: "Buscar",
    lengthMenu: "<span>Mostrar</span> _MENU_ <span>elementos</span>",
    info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
    infoEmpty: "Mostrando ningún elemento.",
    infoFiltered: "(filtrado _MAX_ elementos total)",
    infoPostFix: "",
    loadingRecords: "Cargando registros...",
    zeroRecords: "No se encontraron registros",
    emptyTable: "No hay datos disponibles en la tabla",
    paginate: {
      first: "<<",
      previous: "<",
      next: ">",
      last: ">>"
    },
    aria: {
      sortAscending: ": Activar para ordenar la tabla en orden ascendente",
      sortDescending: ": Activar para ordenar la tabla en orden descendente"
    },
    buttons: {
      colvis: 'Seleccionar columnas'
    }
  }

  public static custom_dom_datatables =
    '<"container"' +
    '<"row mt-3 justify-content-between"' +
    '<"col-auto ps-0 me-auto datatable-length-selector"l>' +
    '<"col pe-0 ms-auto datatable-filters-container"f>' +
    '>' +
    '<"row mt-3"' +
    '<"col me-auto px-0"' +
    '<"table-responsive"t>' +
    '>' +
    '>' +
    '<"row my-3 justify-content-between"' +
    '<"col me-auto"i>' +
    '<"col-md-auto ms-auto"p>' +
    '>';
}
